<template>
  <base-page-layout title="Lojas">
    <v-container class="py-0 px-0" fluid>
      <mf-loading-dialog :loading="initialLoader">
        <units-group-container ref="unitsGroupContainer" />
        <mf-card-container
          v-model="search"
          title="Gerenciamento das lojas"
          description="Você pode ver nessa tabela lojas as quais tem acesso. A ordem definida aqui e os marcadores criados são apresentados nos filtros da plataforma. Para aplicar as mudanças, clique em salvar."
          use-search
          placeholder="Busca"
          class="mb-5 units-management"
        >
          <v-data-table :headers="headers" :items="sortedItems" :loading="loading" hide-default-footer disable-pagination>
            <template v-slot:body="{ items }">
              <tbody v-if="items.length === 0">
                <tr class="v-data-table__empty-wrapper">
                  <td colspan="5">Nenhum resultado encontrado</td>
                </tr>
              </tbody>
              <tbody is="transition-group" v-else name="list">
                <tr v-for="(item, index) in sortedItems" :key="item.id_erp" class="list-item">
                  <td class="nowrap-row">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span :class="[item.active ? null : 'disabled-text']" v-on="item.id_erp.length > 24 ? on : null">{{
                          getFormatedText(item.id_erp, 24)
                        }}</span>
                      </template>
                      <span v-if="item.id_erp.length > 24" :class="[item.active ? null : 'disabled-text']">{{ item.id_erp | hifen }}</span>
                    </v-tooltip>
                  </td>
                  <td class="nowrap-row">
                    <v-tooltip max-width="250" top>
                      <template v-slot:activator="{ on }">
                        <span :class="[item.active ? null : 'disabled-text']" v-on="item.name.length > 20 ? on : null">{{
                          getFormatedText(item.name, 20)
                        }}</span>
                      </template>
                      <span v-if="item.name.length > 20" :class="[item.active ? null : 'disabled-text']">{{ item.name | hifen }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <span :class="[item.active ? null : 'disabled-text']">{{ item.cnpj | cnpj }}</span>
                  </td>
                  <td class="nowrap-row">
                    <v-tooltip max-width="250" top>
                      <template v-slot:activator="{ on }">
                        <span :class="[item.active ? null : 'disabled-text']" v-on="item.address.length > 40 ? on : null">{{
                          getFormatedText(item.address, 40)
                        }}</span>
                      </template>
                      <span v-if="item.address.length > 40" :class="[item.active ? null : 'disabled-text']">{{ item.address | hifen }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <span :class="[item.active ? null : 'disabled-text']">{{ item.ecommerce_v2_active ? 'Sim' : 'Não' }}</span>
                  </td>
                  <td>
                    <unit-tags
                      v-if="item.active"
                      :unit-tags.sync="item.tags"
                      :availableTags="tagList"
                      @change="updateLocalUnitList($event, item.id_erp)"
                      @new-tag="createNewTag($event, item.id_erp)"
                      @delete-tag="deleteUnitTag($event)"
                      @update-tag-name="updateTagName($event)"
                    />
                    <v-row v-else no-gutters class="py-0 px-0" justify="start">
                      <span class="tag-disabled-color tag mr-2"> Loja desabilitada </span>
                    </v-row>
                  </td>
                  <td>
                    <mf-tooltip top max-width="200px">
                      <template #activator="{ on }">
                        <mf-button :disabled="!item.active" type="icon" color="cinza-0" icon="edit_square" @click="item.active && openUnitModal(item)" />
                      </template>
                      <span>{{ item.active ? 'Editar loja' : 'Loja desabilitada' }}</span>
                    </mf-tooltip>
                  </td>
                  <td class="px-0">
                    <mf-button
                      color="cinza-0"
                      type="icon"
                      icon="arrow_drop_up"
                      size="sm"
                      :disabled="search || !item.active ? true : false"
                      @click="rearrangeUnitsOrder(index - 1, index)"
                    />
                    <mf-button
                      color="cinza-0"
                      type="icon"
                      icon="arrow_drop_down"
                      size="sm"
                      :disabled="search || !item.active ? true : false"
                      @click="rearrangeUnitsOrder(index + 1, index)"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </mf-card-container>

        <mf-action-buttons
          :primary-button="{
            text: 'Salvar',
            action: save,
            isVisible: true,
            isLoading: loading,
          }"
          :extra-button="{
            text: 'Restaurar',
            action: restore,
            isVisible: true,
            isLoading: loading,
          }"
        />
      </mf-loading-dialog>
      <loja-edicao v-if="editing" v-model="editing" :unit="selectedUnit" :saveCallback="editUnit" />
    </v-container>
  </base-page-layout>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import truncate from 'lodash/truncate'
import { deepDelete } from '@/helpers/deepDelete'
import { mapWaitingActions } from 'vue-wait'
import { MUTATION_UNIT, MUTATION_UNITS_ORDER } from '@/modules/configuracoes/lojas/graphql'
export default {
  name: 'Lojas',
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    LojaEdicao: () => import('@/modules/configuracoes/lojas/views/components/LojaEdicao.vue'),
    UnitTags: () => import('@/modules/configuracoes/lojas/views/components/UnitTags.vue'),
    UnitsGroupContainer: () => import('@/modules/configuracoes/lojas/views/components/UnitsGroupContainer.vue'),
  },
  data: () => ({
    search: '',
    items: [],
    showTooltipDescription: {},
    editing: false,
    selectedUnit: {},
    loading: false,
    initialLoader: false,
    localUnits: [],
  }),
  computed: {
    sortedItems() {
      const sortedItems = [...this.items].sort((a, b) => (a.active !== false && b.active === false ? -1 : 1))
      return sortedItems
    },
    deletedTag() {
      return this.$store.getters.deletedTag
    },
    updatedTag() {
      return this.$store.getters.updatedTag
    },
    tagList() {
      return this.$store.getters.tagList
    },
    units() {
      return this.$store.getters.units
    },
    headers() {
      return [
        {
          text: 'ID',
          value: 'id_erp',
          width: '5%',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'name',
          width: '15%',
          sortable: false,
        },
        {
          text: 'CNPJ',
          value: 'cnpj',
          width: '14%',
          sortable: false,
        },
        {
          text: 'Endereço',
          value: 'address',
          width: '20%',
          sortable: false,
        },
        {
          text: 'E-commerce',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Marcadores',
          width: '30%',
          sortable: false,
        },
        {
          text: '',
          width: '5%',
          sortable: false,
        },
        {
          text: '',
          width: '1%',
          sortable: false,
        },
      ]
    },
  },
  watch: {
    search(value) {
      this.items = this.searchUnits(value)
    },
    deletedTag(value) {
      this.localUnits.forEach((unit) => {
        if (unit.tags) {
          unit.tags = unit.tags.filter((tag) => tag.name !== value.name)
        }
      })
    },
    updatedTag(value) {
      this.localUnits.forEach((unit) => {
        if (unit.tags) {
          const index = unit.tags.findIndex((tag) => tag.name === value.oldName)
          if (index > -1) {
            unit.tags[index].name = value.newName
          }
        }
      })
    },
    localUnits: {
      handler() {
        this.items = this.searchUnits(this.search)
      },
      deep: true,
    },
    units: {
      handler(list) {
        this.localUnits = cloneDeep(list)
        this.loading = false
        this.initialLoader = false
      },
      immediate: true,
    },
  },
  methods: {
    ...mapWaitingActions({
      fetchUnits: 'fetch-units',
    }),
    searchUnits(value) {
      if (value === '') {
        return this.localUnits
      }
      const numValue = value.replace(/[^0-9]/g, '')
      return this.localUnits.filter((item) => {
        return (
          item.name?.toLowerCase().includes(value.toLowerCase()) ||
          item.id_erp?.includes(value) ||
          (numValue && item.cnpj?.includes(numValue)) ||
          (item.tags &&
            item.tags
              .map((tag) => tag.name.toLowerCase())
              .toString()
              .includes(value.toLowerCase()))
        )
      })
    },
    updateLocalUnitList(value, id_erp) {
      const units = cloneDeep(this.localUnits)
      units.filter((unit) => unit.id_erp === id_erp).forEach((unit) => (unit.tags = value))
      this.localUnits = units
    },
    getFormatedText(text, length) {
      return truncate(text, {
        length: length,
        separator: ' ',
      })
    },
    openUnitModal(unit) {
      this.selectedUnit = cloneDeep(unit)
      this.editing = true
    },
    async editUnit(unit) {
      this.search = ''
      deepDelete(unit, ['__typename', 'id_erp', 'pdv_token', 'tags', 'ecommerce_v2_active', 'active', 'unit_group', 'ecommerce_partner'])
      await this.$apollo.mutate({
        mutation: MUTATION_UNIT,
        variables: { data: unit },
      })
      this.$refs.unitsGroupContainer.updateTable()
      await this.fetchUnits()
    },

    rearrangeUnitsOrder(newPosition, oldPosition) {
      if (newPosition < 0) return
      if (newPosition >= this.sortedItems.length) return
      let items = cloneDeep(this.sortedItems)
      const currentItem = items[oldPosition]
      const affectedItem = items[newPosition]

      items[oldPosition] = affectedItem
      items[newPosition] = currentItem

      this.localUnits = cloneDeep(items)
    },

    async save() {
      this.search = ''
      this.loading = true
      const units = this.items.map((unit, index) => {
        return {
          _id: unit._id,
          position: index,
          tags: unit.tags,
        }
      })
      deepDelete(units, '__typename')
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_UNITS_ORDER,
          variables: {
            data: units,
          },
        })
        this.$snackbar({ message: 'Atualizado com sucesso!', snackbarColor: 'success' })
        this.fetchUnits()
      } catch {
        this.$snackbar({ message: 'Ocorreu um erro, tente novamente mais tarde.', snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
    },
    async restore() {
      this.search = ''
      this.loading = true
      try {
        await this.fetchUnits()
      } catch {
        this.$snackbar({ message: 'Ocorreu um erro, tente novamente mais tarde.', snackbarColor: 'error' })
      }
    },
    createNewTag(tags, id) {
      this.$store.commit('SET_TAG_LIST', tags)
      this.updateLocalUnitList(tags, id)
    },
    deleteUnitTag(deletedTag) {
      this.$store.commit('DELETED_TAG', deletedTag)
      this.$store.commit(
        'SET_TAG_LIST',
        cloneDeep(this.tagList).filter((item) => item.name !== deletedTag.name)
      )
    },
    updateTagName(updatedTag) {
      const tagList = cloneDeep(this.tagList)
      const index = tagList.findIndex((tag) => tag.name === updatedTag.oldName)
      if (index < 0) return
      tagList[index].name = updatedTag.newName
      this.$store.commit('UPDATED_TAG', { oldName: updatedTag.oldName, newName: updatedTag.newName })
      this.$store.commit('SET_TAG_LIST', tagList)
    },
  },
}
</script>
<style lang="scss">
.units-management {
  th {
    @extend .column-title;
  }
  td {
    @extend .texto-corrido;
  }
  .section-subtitle {
    @extend .texto-corrido;
    word-break: break-word;
  }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
    transform: translateY(100%);
  }
  .list-move {
    transition: transform 0.4s;
  }
  .list-item {
    display: table-row;
  }

  .tag-disabled-color {
    background-color: $cinza-l80;
    color: $cinza-l10;
  }
  .disabled-link {
    color: $cinza-l20;
    font-size: 14px;
    font-weight: $font-weight-regular;
    line-height: $line-height-text;
    letter-spacing: $letterspacing-1;
    text-decoration: underline;
  }
  .disabled-text {
    color: $cinza-l20;
  }
}
</style>
